module.exports = __webpack_public_path__ + "static/headphones-lady-desktop-8d7d052dbc7382341874896461d177d5.jpg";